import React from 'react';
import { Tooltip } from 'devextreme-react/tooltip';
import styles from './AlertWidget.styles';
import {
    Paper,
    Typography,
    withStyles,
} from '@material-ui/core';
import { Colours } from '../FieldsWidget/FieldsWidget.constants';
import { withRouter } from 'react-router';
import { IAlertFieldProps, IHeadingProps, ILabelMessageProps, ILinkProps } from './AlertWidget.properties';
import { generateURL } from '../Widgets.utils';

const LabelMessage = ({ classes, message, description }: ILabelMessageProps) => {
    const warningIconRef = React.useRef<HTMLElement>();
    const [alertHover, setAlertHover] = React.useState(false);
    const [alertClick, setAlertClick] = React.useState(false);

    return (
        <div className={classes.alertMessageDiv}>
            <span
                ref={warningIconRef}
                onMouseEnter={() => { setAlertHover(true); }}
                onMouseLeave={() => { setAlertHover(false); }}
                onClick={() => { setAlertClick(true); }}
            >
                {message}
                <Tooltip
                    target={warningIconRef.current}
                    visible={alertHover || alertClick}
                    hideOnOutsideClick={true}
                    onHiding={() => { setAlertClick(false); }}>
                    {description}
                </Tooltip>
            </span>
        </div>
    );
};

const Link = ({ classes, history, location, url, children }: ILinkProps) => {
    return (
        <div
            onClick={() => {
                history.push(generateURL(location, url));
            }}
            className={classes.alertLink}
        >
            {children}
        </div>
    );
};

const AlertField = ({ classes, alert }: IAlertFieldProps) => {

    return (
        <Paper
            className={classes.alertItem}
            style={{ backgroundColor: `${Colours[alert?.Colour] || '#fff'}` }}
        >
            <Typography variant='subtitle2' className={classes.alertTitle} style={{
            }}>
                {alert.Link ? (
                    <LinkComponent url={alert.Link}>
                        <LabelMessageComponent description={alert?.Description} message={alert?.Message} />
                    </LinkComponent>
                ) :
                    <LabelMessageComponent description={alert?.Description} message={alert?.Message} />
                }
            </Typography>
        </Paper>
    );
};

const Heading = ({ classes, showHeading, heading }: IHeadingProps) => {
    if (!showHeading) return (<React.Fragment></React.Fragment>);

    return (
        <Typography variant='h6' className={classes.heading}>
            {heading}
        </Typography>
    );
};

export default withStyles(styles)(AlertField);
export const LinkComponent = withRouter(withStyles(styles)(Link));
export const LabelMessageComponent = withStyles(styles)(LabelMessage);
export const HeadingComponent = withStyles(styles)(Heading);
